import formatPrescriberName from 'utils/formatPrescriberName';

const getPrescriberName = ({ patient, prescriber, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (prescriber && prescriber['First Name']) {
    return formatPrescriberName(prescriber).toUpperCase();
  }
  if (patient.Prescriber[0]) {
    return formatPrescriberName(patient.Prescriber[0]).toUpperCase();
  }
  return null;
};

export default getPrescriberName;



// WEBPACK FOOTER //
// ./src/utils/print/getPrescriberName.js